import { inject, Injectable, isDevMode } from '@angular/core';
import { type MissingTranslationHandler, type MissingTranslationHandlerParams } from '@ngx-translate/core';
import { BugsnagClient } from '../bugsnag/bugsnag-client';

@Injectable({
  providedIn: 'root',
})
export class RcpMissingTranslationHandlerService implements MissingTranslationHandler {
  private bugsnagClient = inject(BugsnagClient);

  handle(params: MissingTranslationHandlerParams): any {
    const error = `Missing translation for key ${params.key}`;

    if (isDevMode()) {
      console.error(error);
    }

    this.bugsnagClient.notify(new Error(error), {}, 'CustomError');
  }
}
